import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Button, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Modal} from 'react-bootstrap';
import validator from 'validator';

class AddItemModal extends Component {

  constructor(props) {
    super(props);

    this.initialState = {
      text: '',
      outcome: '',
      measured: '',
      validation: {}
    };

    this.state = {
      ...this.initialState
    };
  }

  validate = () => {
    let valid = true;
    let validation = {};

    if (this.props.type === 'Goal') {
      if (validator.isEmpty(this.state.outcome)) {
        validation.outcome = 'This is required.';
        valid = false;
      }
      if (validator.isEmpty(this.state.measured)) {
        validation.measured = 'This is required.';
        valid = false;
      }
    } else {
      if (validator.isEmpty(this.state.text)) {
        validation.text = 'This is required.';
        valid = false;
      }
    }

    this.setState({ validation });

    return valid;
  };

  addItem = () => {
    if (this.validate()) {
      switch (this.props.type) {
        case 'Recommendation':
          this.props.addRecommendation(this.state.text);
          break;
        case 'Agreement':
          this.props.addAgreement(this.state.text);
          break;
        case 'Goal':
          this.props.addGoal({ outcome: this.state.outcome, measured: this.state.measured });
          break;
        default:
          this.props.handleHide();
      }

      this.setState({ ...this.initialState });
    }
  };

  handleChange = (event) => {
    let target = event.target;

    this.setState({ [target.name]: target.value });
  };

  render() {
    return (
      <div>
        <Modal
          data-cy='add-item-modal'
          show={this.props.show}
          onHide={this.props.handleHide}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Add {this.props.type}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {
                this.props.type !== 'Goal' ?
                  <FormGroup>
                    <FormGroup validationState={this.state.validation.text ? 'error' : null} controlId="formHorizontalText">
                      <ControlLabel>
                        { this.props.type === 'Recommendation' ? 'Recommendation' : 'Agreement' }
                      </ControlLabel>
                      <FormControl name="text" componentClass="textarea" type='text' value={this.state.text} onChange={this.handleChange}/>
                      {this.state.validation.text ? <HelpBlock>{this.state.validation.text}</HelpBlock> : null}
                    </FormGroup>
                  </FormGroup>
                  :
                  <Fragment>
                    <FormGroup validationState={this.state.validation.outcome ? 'error' : null} controlId="formHorizontalOutcome">
                      <ControlLabel>
                        Outcome
                      </ControlLabel>
                      <FormControl name="outcome" componentClass="textarea" type='text' value={this.state.outcome} onChange={this.handleChange}/>
                      {this.state.validation.outcome ? <HelpBlock>{this.state.validation.outcome}</HelpBlock> : null}
                    </FormGroup>
                    <FormGroup validationState={this.state.validation.measured ? 'error' : null} controlId="formHorizontalMeasured">
                      <ControlLabel>
                        As Measured By
                      </ControlLabel>
                      <FormControl name="measured" componentClass="textarea" type='text' value={this.state.measured} onChange={this.handleChange}/>
                      {this.state.validation.measured ? <HelpBlock>{this.state.validation.measured}</HelpBlock> : null}
                    </FormGroup>
                  </Fragment>
              }
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button data-cy='add-button' className='primary' onClick={this.addItem}>Add {this.props.type}</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

AddItemModal.propTypes = {
  show: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  addAgreement: PropTypes.func.isRequired,
  addRecommendation: PropTypes.func.isRequired,
  addGoal: PropTypes.func.isRequired,
  handleHide: PropTypes.func.isRequired,
};

export default AddItemModal;



// WEBPACK FOOTER //
// ./src/components/engagement/AddItemModal.js